import React, { useMemo } from "react";
import { formatSalesValue } from "../../utils/formatUtils";
import { groupItemsByType } from "../../utils/menuUtils";

export const MenuItemsGroupedTable = ({ items }) => {
    const typeGroups = useMemo(() => groupItemsByType(items), [items]);

    return (
        <div className="space-y-5">
            {typeGroups.map(({ type, groups }) => (
                <div key={type}>
                    {/* Type label */}
                    <div className="px-4 py-1.5 mb-1.5 bg-violet-100 text-violet-600 rounded-sm text-xs font-semibold uppercase tracking-widest max-w-fit">
                        {type}
                    </div>

                    <div className="overflow-x-auto tiny-scrollbar rounded-md border border-gray-100">
                        <table className="w-full text-sm">
                            <thead className="bg-gray-50">
                                <tr>
                                    {[
                                        { label: "Name", className: "text-left" },
                                        { label: "Price", className: "text-right" },
                                        { label: "Discount", className: "text-center" },
                                        { label: "Service", className: "text-center" },
                                    ].map(({ label, className }) => (
                                        <th
                                            key={label}
                                            className={`${className} px-3 py-2.5 text-xs font-semibold uppercase tracking-widest text-gray-600`}
                                        >
                                            {label}
                                        </th>
                                    ))}
                                </tr>
                            </thead>
                            <tbody className="divide-y divide-gray-200">
                                {groups.map((group, gi) => (
                                    <React.Fragment key={`${type}-${gi}`}>
                                        {group.description && (
                                            <tr className="bg-blue-50">
                                                <td colSpan={4} className="px-3 py-1.5 text-left font-semibold text-blue-700 tracking-wide">
                                                    {group.description}
                                                </td>
                                            </tr>
                                        )}
                                        {group.items.map((item) => (
                                            <tr key={item.id} className="hover:bg-gray-50 transition">
                                                <td className="px-3 py-2 text-left text-gray-800">{item.Name}</td>
                                                <td className="px-3 py-2 text-right font-medium text-gray-700">{formatSalesValue(item.Price)}</td>
                                                <td className="px-3 py-2 text-center text-gray-600">{item.discountExempt}</td>
                                                <td className="px-3 py-2 text-center text-gray-600">{item.serviceChargeExempt}</td>
                                            </tr>
                                        ))}
                                    </React.Fragment>
                                ))}
                            </tbody>
                        </table>
                    </div>
                </div>
            ))}
        </div>
    );
};

export const MenuItemsSummaryFooter = ({ items }) => {
    const typeGroups = useMemo(() => groupItemsByType(items), [items]);

    return (
        <div className="flex flex-wrap items-center gap-x-5 gap-y-1 text-sm text-gray-600">
            {typeGroups.map(({ type, itemCount, groupCount }) => (
                <span key={type} className="font-semibold text-gray-700">
                    {type}:{" "}
                    {itemCount} item{itemCount === 1 ? "" : "s"}, {groupCount} group{groupCount === 1 ? "" : "s"}
                </span>
            ))}
        </div>
    );
};